// 点击后获取当前用户生成的绑定二维码
<template>
  <div class="qrcode-wrapper">
    <div class="label">
      <span>请务必关注公众号，否则不能及时接收有关通知；<br />系统使用过程中遇到问题，也可在公众号中直接咨询。</span>
      <i class="el-icon-caret-right" style="position: absolute;right: -14px;font-size: 24px;color: #FFFDD9;top: 50%;transform: translateY(-50%);"></i>
    </div>
    <div class="pup">
    <el-popover
      trigger="click"
      title="请打开手机微信，扫描下方二维码"
      @show="handleFetchQrCode"
    >
      <el-skeleton style="width: 240px" :loading="!isInitial" animated>
        <template slot="template">
          <el-skeleton-item
            variant="image"
            style="width: 200px; height: 200px"
          />
        </template>
        <template>
          <div>
            <img style="width: 200px; height: 200px" :src="imageBase64" />
          </div>
        </template>
      </el-skeleton>

      <svg-icon icon-class="qrcode" class="qrcode-svg" slot="reference" />
    </el-popover>
    </div>

  </div>
</template>
<script>
import { fetchNewQrCode } from "@/api/qrcode";

export default {
  name: "QrCode",
  data() {
    return {
      imageBase64: "",
      isInitial: false,
    };
  },
  methods: {
    async handleFetchQrCode() {
      if (!this.isInitial) {
        const { data } = await fetchNewQrCode();
        this.imageBase64 = data;
        this.isInitial = true;
      }
    },
  },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.qrcode-wrapper {
  display: flex;
  position: relative;
  .label {
    font-size: 14px;
    color: #FF4200;
    background-color: #FFFDD9;
    border-radius: 5px;
    padding: 10px 15px;
    line-height: 1.2;
    flex: 1;
    margin-right: 40px;
    position: relative;
  }
  .pup{
    flex: 1;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  .qrcode-svg {
    height: 34px;
    width: 34px;
    padding: 4px;
    border-radius: 5px;
    cursor: pointer;
    color: #159443;
    margin-left: 10px;
    background-color: #E6FFEF;
    border: 1px solid #9DD5B2;
  }

}
</style>
<style lang="scss">
  @media (max-width:1500px){
   .qrcode-wrapper{
     width: 500px;
   }
  }
  @media (max-width:1370px){
   .qrcode-wrapper{
     width: 450px;
   }
  }
  @media (max-width:1000px){
    .qrcode-wrapper{
      width: 380px;
      .label{
        font-size: 12px !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/QrCode.vue